import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { BaseService } from './base.service';
import { DiversityType, FormTemplate, SupplierSurvey, SurveyRequest } from '../models/onboarding.model';
import { AppSettings } from '../../app.settings';
import { SupplierContact } from '../models/supplier.model';

@Injectable()
export class OnboardingService extends BaseService {

    constructor(private http: HttpClient, private config: AppSettings) {
        super();
    }

    /** Sends POST request to save onboarding survey request*/
    postSurvey(surveyRequest: SurveyRequest) : Observable<SupplierSurvey> {
        const url = `${this.config.BaseUrl}Profile/Onboarding/SaveSurvey/${surveyRequest.SupplierCode}`;
        return this.http.post<SupplierSurvey>(url, surveyRequest, { headers: this.setHeaders() });
    }

    /** Gets saved survey details */
    getSurvey(supplierCode: string) : Observable<SupplierSurvey> {
        const url = `${this.config.BaseUrl}Profile/Onboarding/${supplierCode}/GetSurvey`;
        return this.http.get<SupplierSurvey>(url, { headers: this.setHeaders() });
    }

    /** Sends GET request to get training documents */
    getTrainingDocuments(onboardingType: 'extended' | 'initial'): Observable<{ title: string, url: string }[]> {
        const url = `${this.config.BaseUrl}Profile/Onboarding/${onboardingType}/Training/Documents`;
        return this.http.get<{ title: string, url: string }[]>(url);
    }

    /** Sends GET request to get form template */
    getFormTemplate(formType: string): Observable<FormTemplate> {
        const url = `${this.config.BaseUrl}Profile/Onboarding/GetTemplate/${formType}`;
        return this.http.get<FormTemplate>(url);
    }

    /** Sends GET request to get peding signature contracts */
    isPendingContractSignatureTask(supplierCode: string): Observable<boolean> {
        const url = `${this.config.BaseUrl}Profile/Onboarding/IsPendingContractSignatureTask/${supplierCode}`;
        return this.http.get<boolean>(url);
    }

    getContactsBySupplierCode(supplierCode: string, taskId:number = 0): Observable<SupplierContact[]>
    {
      const url = `${this.config.BaseUrl}Profile/Onboarding/GetContactsBySupplierCode/${supplierCode}?portalTaskId=${taskId}`;
      return this.http.get<SupplierContact[]>(url);
    }

    getMsmeFieldConfig(remitToCountry: string): Observable<any>
    {
      const url = `${this.config.BaseUrl}Profile/Onboarding/GetMsmeConfig/${remitToCountry}`;
      return this.http.get<any>(url);
    }

    isMsmeEligible(remitToCountry: string, formResponse: any){
        const url = `${this.config.BaseUrl}Profile/Onboarding/IsMsmeEligible/${remitToCountry}`;
        return this.http.post<boolean>(url, formResponse, { headers: this.setHeaders() });
    }
}
